<template>
  <RestaurantDeliveriesForm :typeEndPoint="'restaurantDeliveriesForm'" :dataParams="{}"/>
</template>
<script>
import RestaurantDeliveriesForm from '@/components/modules/restaurant/deliveries/form'
export default {
  name: 'RestaurantDeliveriesFormCreate',
  components: {
    RestaurantDeliveriesForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/restaurant/deliveries/create.vue